const POLLS_FLOW_KEY = 'tgx-onboarding-flow'
const POLLS_REF_KEY = 'tgx-polls-onboarding-ref'
const POLLS_FLOW_FALLBACK_KEY = 'tgx-onboarding-flow-fallback'
const POLLS_REF_FALLBACK_KEY = 'tgx-polls-onboarding-ref-fallback'

export interface PollsFlowState {
  active: boolean
  ref: string | null
}

export function getPollsFlow(): PollsFlowState {
  try {
    let active = sessionStorage.getItem(POLLS_FLOW_KEY) === 'polls'
    let ref = sessionStorage.getItem(POLLS_REF_KEY)

    if (!active) {
      active = localStorage.getItem(POLLS_FLOW_FALLBACK_KEY) === 'polls'
      if (active) {
        ref = ref || localStorage.getItem(POLLS_REF_FALLBACK_KEY)
        sessionStorage.setItem(POLLS_FLOW_KEY, 'polls')
        if (ref) sessionStorage.setItem(POLLS_REF_KEY, ref)
      }
    }

    return { active, ref }
  } catch {
    return { active: false, ref: null }
  }
}

export function setPollsFlow(ref?: string | null): void {
  try {
    sessionStorage.setItem(POLLS_FLOW_KEY, 'polls')
    localStorage.setItem(POLLS_FLOW_FALLBACK_KEY, 'polls')
    if (ref) {
      sessionStorage.setItem(POLLS_REF_KEY, ref)
      localStorage.setItem(POLLS_REF_FALLBACK_KEY, ref)
    } else {
      sessionStorage.removeItem(POLLS_REF_KEY)
      localStorage.removeItem(POLLS_REF_FALLBACK_KEY)
    }
  } catch {}
}

export function clearPollsFlow(): void {
  try {
    sessionStorage.removeItem(POLLS_FLOW_KEY)
    sessionStorage.removeItem(POLLS_REF_KEY)
    localStorage.removeItem(POLLS_FLOW_FALLBACK_KEY)
    localStorage.removeItem(POLLS_REF_FALLBACK_KEY)
  } catch {}
}
